<script>
    import {sgettext} from '../../../i18n.js';

    export let row = null;

</script>

<ul class="list-unstyled">
  {#each row.override_operations as configured_op}
    {#if configured_op.operation.user_defined}
      <li><span class="text-info" title="{sgettext("$$USERDEFINED$$")}"><i class="fas fa5-user-plus fa-fw"></i> {configured_op.operation.number}</span> - {sgettext("$$USER_DEFINED$$")}</li>
    {:else}
      <li>
        {#if configured_op.override_operation}
          <span class="text-info" title="{sgettext("$$OVERRIDE$$")}"><i class="fas fa5-undo fa-fw"></i> {configured_op.override_operation}</span>
          <del>{configured_op.operation.number}</del> - {configured_op.operation.description}
        {:else}
          <i class="fas fa5-circle fa-fw" style="color: rgba(0,0,0,0)"></i>
          {configured_op.operation.number} - {configured_op.operation.description}
        {/if}
      </li>
    {/if}
  {/each}
</ul>
